var _radialGradient, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 180 612 612",
    enableBackground: "new 0 180 612 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 130.802,
    cy: 895.869,
    r: 968.776,
    gradientTransform: "matrix(.539 -.842 .618 .395 -492.923 652.145)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F9ED32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EE2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002AFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M43.7 180h524.6c24.2 0 43.7 19.6 43.7 43.7v524.6c0 24.2-19.6 43.7-43.7 43.7h-524.6c-24.1 0-43.7-19.6-43.7-43.7v-524.6c0-24.1 19.6-43.7 43.7-43.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 8,
    d: "M413.9 721.5h-215.8c-70.3 0-127.6-57.2-127.6-127.6v-215.8c0-70.3 57.2-127.6 127.6-127.6h215.9c70.3 0 127.6 57.2 127.6 127.6v215.9c-.1 70.3-57.3 127.5-127.7 127.5zm-215.8-431.7c-48.7 0-88.3 39.6-88.3 88.3v215.9c0 48.7 39.6 88.3 88.3 88.3h215.9c48.7 0 88.3-39.6 88.3-88.3v-215.9c0-48.7-39.6-88.3-88.3-88.3h-215.9zm107.9 314c-64.9 0-117.8-52.8-117.8-117.8 0-64.9 52.8-117.8 117.8-117.8 64.9 0 117.8 52.8 117.8 117.8 0 64.9-52.9 117.8-117.8 117.8zm0-196.3c-43.3 0-78.5 35.2-78.5 78.5s35.2 78.5 78.5 78.5 78.5-35.2 78.5-78.5-35.2-78.5-78.5-78.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 9,
    cx: 427.7,
    cy: 364.3,
    r: 25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.a29f7af4a10fcd0c9bc6d1c2e3f2bba6.svg";
export { ForwardRef as ReactComponent };